import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=1fcdfb04&scoped=true&"
import script from "./Crew.vue?vue&type=script&lang=js&"
export * from "./Crew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcdfb04",
  null
  
)

export default component.exports